import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as otpTokenActions from '../../../actions/otpToken';
import cx from 'classnames';

class RevokeToken extends React.Component {
	handleClick() {
		this.props.initOTPToken();
	}

	renderPCIcon() {
			return (
				<div className="securityhome-item__icon securityhome-item__icon--gray securityhome-item__icon--revoke"></div>
			);
	}

	renderMobileIcon() {

			return (
				<div className="securityhome-item__name-icon securityhome-item__name-icon--gray securityhome-item__name-icon--revoke"></div>
			);

	}

	renderTitle() {
			return (
				<div className="securityhome-item__name">
					{this.renderMobileIcon()}
					<span className="securityhome-item__valname">取消全部信任裝置</span>
					{isMobile ? <span className="securityhome-item__val">取消全部信任裝置</span> : null}
				</div>
			);
	}

	renderAction() {
			return (
				<div className="securityhome-item__op">
					<a href="#" className="securityhome-item__link" onClick={this.handleClick.bind(this)}>
						取消
					</a>
				</div>
			);
	}

	render() {
		return (
			<div className="securityhome-item">
				{this.renderPCIcon()}
				<div className="securityhome-item__txt">
					{this.renderTitle()}
					<div className="securityhome-item__desc">
						若您在公用電腦上的遊戲兩步驟驗證鎖中，不慎勾選了「信任此裝置 30 天」，可以從這裡取消所有的信任裝置設定。
					</div>
				</div>
				{this.renderAction()}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, otpTokenActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RevokeToken);


// WEBPACK FOOTER //
// ./app/components/security/main_panel/RevokeToken.js